const $ = jQuery.noConflict();

const Forms = () => {
    const hubspotForm = document.querySelectorAll('.hbspt-form form.hs-custom-style');

    // Remove hubspot's styling from forms
    if (hubspotForm) {
        hubspotForm.forEach(
            function (form) {
                form.classList.remove('hs-custom-style');
            }
        );
    }

    const initCheckbox = input => {
        $(input).hide().next().prepend('<div class="input-box"></div>');
    };

    $('input[type="checkbox"]:visible, input[type="radio"]:visible').each((index, input) => initCheckbox(input));

    $(document).bind('gform_post_render', () => {
        $('input[type="checkbox"]:visible, input[type="radio"]:visible').each((index, input) => initCheckbox(input));
    });
};

export default Forms;
